import DispatchConstants from '../constants/DispatchConstants';

export const initialState = {
  isProduction: __PROD__,
  zgEnv: 'local',
  zgApi: '',
  zgApiPublic: '',
  nodeEnv: 'development',
  metroidAlicornHppConfigId: '',
  metroidAlicornUrl: '',
};

const env = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case DispatchConstants.SET_ENV:
      return { ...state, ...payload };
    default:
  }
  return state;
};

export default env;
